module.exports = __webpack_public_path__ + "static/media/fa-light-300.29fbe84e.svg";